import React, { useEffect, useState } from "react";
import ExpenseForm from "./components/ExpenseForm";
import ExpenseList from "./components/ExpenseList";
import Filters from "./components/Filters";
import Summary from "./components/Summary";
import Charts from "./components/Charts";
import Login from "./components/Login";
import "./App.css";

const LOCAL_STORAGE_KEY = "expenseTrackerData";

const App = () => {
  const [expenses, setExpenses] = useState([]);
  const [filters, setFilters] = useState({ category: "", date: "" });
  const [showSummary, setShowSummary] = useState(false);
  const [showCharts, setShowCharts] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // LOGIN STATE

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn");
    if (loggedIn === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    const storedExpenses = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    if (storedExpenses) setExpenses(storedExpenses);
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(expenses));
  }, [expenses]);

  const addExpense = (expense) => {
    setExpenses((prev) => [...prev, expense]);
  };

  const deleteExpense = (id) => {
    setExpenses((prev) => prev.filter((e) => e.id !== id));
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  const filteredExpenses = expenses.filter((e) => {
    const matchCategory = filters.category ? e.category === filters.category : true;
    const matchDate = filters.date ? e.date === filters.date : true;
    return matchCategory && matchDate;
  });

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  return (
    <div className="container">
      {/* 🔓 LOGOUT BUTTON */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>💸 Expense Tracker</h1>
        <button onClick={handleLogout} style={{
          padding: "8px 16px",
          background: "#ff4d4d",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer"
        }}>
          Logout
        </button>
      </div>

      <ExpenseForm onAdd={addExpense} />
      <Filters filters={filters} setFilters={setFilters} />

      <div className="toggle-buttons">
        <button onClick={() => setShowSummary(!showSummary)}>
          {showSummary ? "Hide" : "Show"} Monthly Summary
        </button>
        <button onClick={() => setShowCharts(!showCharts)}>
          {showCharts ? "Hide" : "Show"} Charts
        </button>
      </div>

      {showSummary && <Summary expenses={expenses} />}
      {showCharts && <Charts expenses={expenses} />}

      <ExpenseList expenses={filteredExpenses} onDelete={deleteExpense} />
    </div>
  );
};

export default App;
